Beef.module("ReshareOfPicker").addInitializer(function(startupOptions) {

    this.View = Beef.ReshareOfReplyToPicker.View.extend({
        template: require("@/dashboards/filter/pickers/sharing/ReshareOfPicker.handlebars"),

        mentionPredicate: {
            label: "Recently viewed mentions that have reshares",
            fn: function(m) { return m.reshareCount > 0 }
        }
    });

    this.converter = Beef.ReshareOfReplyToPicker.createConverter("Reshare of", "reshare");

    /**
     * Attach a reshare of picker to a view attribute identified by selector. Updates attribute in the view's model.
     */
    this.attach = function(view, selector, attribute) {
        Beef.Picker.attachPicker(view, selector, attribute, this.View);
    };

});
